import Modal from 'react-bootstrap/Modal'
import useGetCards from '../hooks/useGetCards'
import { useLocation, useNavigate } from 'react-router-dom'
import DotsLoading from 'components/loadings/dotsLoading'
import { BankConvertor } from 'utilities/helper/banksConvertor'
interface ISelectCard {
    isOpen: boolean
    name: string
    bank: string
    bankNumber: number
}
interface IModalProps {
    show: boolean
    onHide: () => void
    setOpenCard: React.Dispatch<React.SetStateAction<ISelectCard>>
}
const CardsModal = ({ show, onHide, setOpenCard }: IModalProps) => {
    const { state } = useLocation()
    const { data, isLoading } = useGetCards(state.poolShipId)
    const profile = JSON.parse(localStorage.getItem('profile')!)
    const navigate = useNavigate()
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full py-4 text-xs">
                <p className=" mb-3 text-center">
                    یک شماره حساب برای انتقال وجه انتخاب کنید
                </p>
                <hr />
                {isLoading ? (
                    <DotsLoading />
                ) : (
                    data && (
                        <div className=" px-4">
                            <p className=" text-sm my-2">
                                {' '}
                                حساب های {profile?.first_name}{' '}
                                {profile?.last_name}
                            </p>
                            <button
                                type="button"
                                className="bg-green-main text-green-1  rounded-md py-2 my-2 w-full"
                                onClick={() =>
                                    navigate('/manage-bank-cards/add')
                                }
                            >
                                ثبت شماره حساب جدید
                            </button>
                            {data.receivers.map((item) => (
                                <div key={item.id}>
                                    {item.bankaccounts.map((bank) => (
                                        <div
                                            className=" flex justify-start bg-header-bg rounded-lg py-2 px-3 items-center  my-2"
                                            onClick={() =>
                                                setOpenCard({
                                                    isOpen: false,
                                                    name: bank.full_name,
                                                    bank: bank.bank_name,
                                                    bankNumber: bank.id,
                                                })
                                            }
                                            key={item.id}
                                        >
                                            <img
                                                src={
                                                    BankConvertor[
                                                        bank.bank_unique_code
                                                    ]
                                                }
                                                alt="bank"
                                                className=" w-10 h-10"
                                            />
                                            <div className=" mr-3">
                                                <p>{bank.full_name}</p>
                                                <p className=" mt-2">
                                                    {bank.card_number
                                                        ? bank.card_number
                                                              .match(/.{1,4}/g)
                                                              ?.join(' ')
                                                        : bank.iban
                                                              .match(/.{1,4}/g)
                                                              ?.join(' ')}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    )
                )}
            </div>
        </Modal>
    )
}

export default CardsModal
